var klaviyoInterval = setInterval(() => {
   if(document.querySelector('[data-testid="klaviyo-form-RGdyE8"]') != null)
   {
       window.submitKlaviyo();
       clearInterval(klaviyoInterval);
   }
}, 1000);
window.submitKlaviyo = function() {

   if(document.querySelectorAll('[data-testid="klaviyo-form-RGdyE8"] button[type="button"]')[1] != undefined && document.querySelectorAll('[data-testid="klaviyo-form-RGdyE8"] button[type="button"]')[1] != null ){
    document.querySelectorAll('[data-testid="klaviyo-form-RGdyE8"] button[type="button"]')[1].addEventListener('click',(e)=>{
        e.preventDefault();
         var submitInterval = setInterval(() => {
             var subText = document.querySelector('.ql-snow.ql-container.ql-disabled');
             if(subText != null) {
                var textEls = document.querySelectorAll('.ql-snow.ql-container.ql-disabled');
                if (textEls.length > 0) {
                    textEls.forEach((item) => {
                        item.closest('[data-testid="form-component"]').classList.add('custom-text-for-klaviyo');
                    })
                }
                clearInterval(submitInterval);
             }
         }, 1000);
    })
   }
}